import { optimizerData } from './shared/state';

export default {
  namespaced: true,
  modules: {
    optimizerData
  }
};
